import { render, staticRenderFns } from "./results.vue?vue&type=template&id=e2354106&scoped=true&"
import script from "./results.vue?vue&type=script&lang=js&"
export * from "./results.vue?vue&type=script&lang=js&"
import style0 from "./results.vue?vue&type=style&index=0&id=e2354106&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2354106",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ElementsSeguroEmpateActivated: require('/var/web/bet777.es/components/elements/seguro-empate-activated.vue').default})
